import styled from 'styled-components';

export const Discount = styled.div`
  display: flex;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.T400};
  padding: 4px;
  line-height: 18px;
  gap: 2px;
  height: 26px;
  width: fit-content;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-left: auto;
  }
`;
